import { ProjectEvaluation } from '@belimo-retrofit-portal/logic';
import { AiResponse } from 'src/modules/common/types/AiResponse';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const EVALUATION_CHANGE = createTrigger<ProjectEvaluation>('EVALUATION_CHANGE');
export const EVALUATION_RESET = createTrigger<void>('EVALUATION_RESET');

export const EVALUATION_PROPOSAL_GENERATE =
  createActions<void, AiResponse>('EVALUATION_GENERATE_PROPOSAL');
